import type { LocationIp } from "./types"
import { normalizeIpCity, isKnownCity } from "./normalizeIpCity"

export function saveLocation(location: LocationIp): void {
  try {
    const locationString = JSON.stringify(location);
    localStorage.setItem('location', locationString);
  } catch (error) {
    console.error("Ошибка при сохранении в localStorage:", error);
  }
}

export function getLocation(): LocationIp {
  // По умолчанию — Москва: основная ЦА и больше всего событий в базе.
  // Пользователь из другого города сменит город сам через шапку.
  const defaultLocation: LocationIp = {
    latitude: 55.7558,
    longitude: 37.6173,
    city: "Москва",
    country: "Российская Федерация",
    region: "Москва"
  };

  try {
    const locationString = localStorage.getItem('location');
    if (locationString) {
      const saved = JSON.parse(locationString) as LocationIp;
      // Город, определённый по IP (или сохранённый раньше без пометки) и отсутствующий в нашем списке,
      // приводим к городу из списка. Выбранный вручную город не трогаем.
      if (saved.source !== "manual" && !isKnownCity(saved.city)) {
        const fixed = normalizeIpCity(saved);
        saveLocation(fixed);
        return fixed;
      }
      return saved;
    } else {
      return defaultLocation;
    }
  } catch (error) {
    console.error("Ошибка при получении из localStorage:", error);
    return defaultLocation;
  }
}

